import {
	useListAllFeatureFlagsQuery,
	useUpdateFeatureFlagMutation,
} from '@/admin/featureFlags/api/featureFlagsApi';

/**
 * Adds a user to, and removes them from, the feature flags that changed in a user drawer
 * (featureFlagChanges, from getFeatureFlagChanges), with one update per flag. Resolves to
 * the names of the flags that failed, so the admin can save again to retry them.
 */
export const useApplyFeatureFlagChanges = () => {
	const [updateFeatureFlag] = useUpdateFeatureFlagMutation();
	const { data: flags = [] } = useListAllFeatureFlagsQuery();

	return async (userId, featureFlagChanges) => {
		const flagIds = [...featureFlagChanges.added, ...featureFlagChanges.removed];
		const flagResults = await Promise.all(
			flagIds.map((id) =>
				updateFeatureFlag({
					id,
					users: featureFlagChanges.added.includes(id) ? { add: [userId] } : { remove: [userId] },
				}),
			),
		);
		return flagIds
			.filter((id, index) => flagResults[index].error)
			.map((id) => flags.find((flag) => flag.id === id)?.feature ?? id);
	};
};
